import styled from 'styled-components';

export const CreateClinicPageStyled = styled.div`
  background-color: #f4f3f3;

  .container-header {
    min-height: 10vh;
    background: linear-gradient(30deg, #9459d0 0%, #027c8b 50%, #0d4693 100%);
    max-width: 100%;

    .imagen {
      text-align: center;
    }
  }

  .container-field {
    min-height: 90vh;
    max-width: 100%;
    width: 70%;
    padding-top: 2%;

    .title {
      padding: 4% 0 0 0;
      display: flex;

      h6 {
        padding-left: 10px;
      }
    }

    .row-field {
      padding: 5px 0px 0px 0px;
    }
  }

  .form-control:focus {
    border-color: #9459d0;
    box-shadow: 0 0 0 0.25rem rgba(128, 0, 128, 0.25);
  }

  .form-select:focus {
    border-color: #9459d0;
    box-shadow: 0 0 0 0.25rem rgba(128, 0, 128, 0.25);
  }

  .container-field,
  .container-header {
    padding: 15px;
  }

  .row-field {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;
  }

  .row-field .col {
    margin-bottom: 10px;
  }

  .btn-salvar-clinica {
    margin-top: 10px;
  }

  @media (max-width: 768px) {
    .container-field {
      padding: 10px;
    }
  }
`;
